import { Component, Input } from '@angular/core';
import { CaseField } from '../../../domain/definition/case-field.model';

@Component({
  selector: 'ccd-field-read-label',
  template: require('./field-read-label.html'),
  styles: [
    require('./field-read-label.scss')
  ]
})
export class FieldReadLabelComponent {

  @Input()
  caseField: CaseField;

  @Input()
  withLabel: boolean;

  public isLabel(): boolean {
    return this.caseField.field_type && this.caseField.field_type.type === 'Label';
  }

  public isComplex(): boolean {
    return this.caseField.field_type && this.caseField.field_type.type === 'Complex';
  }

  public isCaseLink(): boolean {
    return this.isComplex()
      && this.caseField.field_type.id === 'CaseLink'
      && this.caseField.field_type.complex_fields.some(cf => cf.id === 'CaseReference')
  }
}
